<template>
  <slot v-if="showComponent" />
</template>

<script type="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['onChange'],
  props: {
    device: {
      type: String,
      default: 'mobile'
    }
  },
  data () {
    return {
      windowWidth: 767, // Mobile as default
      showComponent: false
    }
  },
  methods: {
    setWindowWidth () {
      this.windowWidth = window.innerWidth || document.documentElement.clientWidth
      this.testComponent()
    },
    testComponent () {
      let show = false
      if (this.windowWidth < 768 && this.device === 'mobile') {
        show = true
      } else if (this.windowWidth >= 768 && this.device === 'desktop') {
        show = true
      } else {
        show = false
      }
      if (show !== this.showComponent) {
        this.showComponent = show
        this.$emit('onChange', this.showComponent)
      }
    }
  },
  mounted () {
    this.setWindowWidth()
    window.addEventListener('resize', this.setWindowWidth)
  },
  unmounted () {
    window.removeEventListener('resize', this.setWindowWidth)
  }
})
</script>
